export default {
  /* eslint-disable no-param-reassign */
  /* eslint-disable no-unused-expressions */
  organizations: state => state.organizations,
  loading: state => state.loading,
  totalPages: state => state.totalPages,
  totalElmts: state => state.totalElmts,
  allOrganizations: state => state.allOrganizations,
  currentOrga: state => state.currentOrga,
  stats: state => state.stats,
};



// WEBPACK FOOTER //
// ./src/store/modules/organizations/getters.js